module.exports = __webpack_public_path__ + "img/all-correct.ccdc749e.jpg";